import _regeneratorRuntime from "@babel/runtime/regenerator";
import _extends from "@babel/runtime/helpers/extends";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import axios from 'axios';
import { createAction } from 'redux-actions';
export var start = createAction('CREATE_SUBSCRIBER_START');
export var success = createAction('CREATE_SUBSCRIBER_SUCCESS');
export var failure = createAction('CREATE_SUBSCRIBER_FAILURE');
/**
 * Creates a new a Lucina subscriber.
 *
 * On the Lucina side, this will trigger a confirmation email to be sent to the user.
 *
 * By default, this action hits Lucina's production API. To customize this to be able to hit Lucina locally and on staging as well, you'll want to pass in an object for `requestConfig`.
 *
 * ```js
 * // in a component
 * import { subscription } from '@minerva-analytics/pantheon';
 *
 * const Test = () => {
 *   const { createSubscriber } = subscription.hooks.useSubscriptionActions();
 *   const email = 'test@gmail.com';
 *   const onClick = () => createSubscriber(email);
 *   return (
 *     <button onClick={onClick}>Subscribe!</button>
 *   )
 * }
 *
 * // outside of a react component (eg. a redux thunk)
 * import { subscription } from '@minerva-analytics/pantheon';
 *
 * dispatch(subscription.actions.createSubscriber(email));
 * ```
 *
 * @param {String} email - The email to use for the new subscriber
 * @param {Object} [requestConfig] - A valid axios request config to customize the request (optional, default `{}`)
 *
 * @returns {Object} - An object that holds the newly created subscriber data
 */

export var createSubscriber = function createSubscriber(email, requestConfig) {
  if (requestConfig === void 0) {
    requestConfig = {};
  }

  return function (dispatch) {
    if (!email) {
      throw new Error('createSubscriber was called without an `email`. Make sure you pass ' + 'an `email` when calling `createSubscriber`: `createSubscriber(email)`');
    }

    dispatch(start());
    return new Promise( /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(resolve, reject) {
        var _requestConfig, response;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return axios(_extends({
                  method: 'post',
                  url: 'https://api-lucina.com/subscribers/'
                }, requestConfig, {
                  data: _extends({}, (_requestConfig = requestConfig) == null ? void 0 : _requestConfig.data, {
                    email: email
                  })
                }));

              case 3:
                response = _context.sent;
                dispatch(success(response));
                resolve(response);
                _context.next = 12;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](0);
                dispatch(failure(_context.t0));
                reject(_context.t0);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 8]]);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }());
  };
};
export default createSubscriber;